import { t } from "@travily/i18n";
import { StandardButton } from "@ui/components/StandardButton";

export interface ProgramsFiltersFooterProps {
  /** Applies the (already-live) refinements by closing the modal. */
  onApply: () => void;
  onClearAll: () => void;
  resultCount: number;
}

export function ProgramsFiltersFooter({ onApply, onClearAll, resultCount }: ProgramsFiltersFooterProps) {
  // Modal.Footer already centers a single child; this row owns the layout.
  // Keyed to the modal's own dialog/sheet split (`md`), not a container query:
  // stacked on the mobile sheet (primary on top, near the thumb), and a
  // clear-left / primary-right row on the desktop dialog.
  return (
    <div className="flex w-full flex-col-reverse gap-3 md:flex-row md:items-center md:justify-between">
      <StandardButton className="max-md:w-full" color="neutral" hierarchy="link" onPress={onClearAll} size="44">
        {t("components.views.programs.search.clear_all")}
      </StandardButton>
      <StandardButton className="max-md:w-full" color="pink" hierarchy="primary" onPress={onApply} size="44">
        {t("components.views.programs.search.show_results", { count: resultCount })}
      </StandardButton>
    </div>
  );
}
